import * as XLSX from "xlsx";

export const exportToExcel = (id: string, filename: string) => {
  const table = document.getElementById(id);
  const workbook = XLSX.utils.table_to_book(table);

  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  const range = XLSX.utils.decode_range(worksheet["!ref"]!);

  for (let col = range.s.c; col <= range.e.c; ++col) {
    const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: col });
    const cell = worksheet[cellAddress];
    if (cell) {
      if (typeof cell.v === "string") {
        cell.v = cell.v.toUpperCase();
      }

      cell.s = {
        fill: { patternType: "solid", fgColor: { rgb: "004AAD" } },
        font: { bold: true, color: { rgb: "white" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }
  }

  // Required to enable styles
  const wopts: XLSX.WritingOptions = {
    bookType: "xlsx",
    type: "binary",
    bookSST: false,
    cellStyles: true,
  };

  XLSX.writeFile(workbook, `${filename}.xlsx`, wopts);
};

const truncateText = (value: any): any => {
  if (typeof value === "string" && value.length > 32767) {
    return value.slice(0, 32764) + "..."; // truncate and append '...'
  }
  return value;
};

export const exportDataToExcel = (data: any[], filename: string) => {
  const cleanData = data.map((row) =>
    Object.fromEntries(Object.entries(row).map(([key, value]) => [key, truncateText(value)]))
  );

  const worksheet = XLSX.utils.json_to_sheet(cleanData);

  // Optional: Style header row
  const range = XLSX.utils.decode_range(worksheet["!ref"]!);
  for (let col = range.s.c; col <= range.e.c; ++col) {
    const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: col });
    const cell = worksheet[cellAddress];
    if (cell) {
      if (typeof cell.v === "string") {
        cell.v = cell.v.toUpperCase();
      }
      cell.s = {
        fill: { patternType: "solid", fgColor: { rgb: "004AAD" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
